module.exports = __webpack_public_path__ + "static/media/BE.50da3946.svg";